import React from 'react';
import { useNavigate } from "react-router-dom"
import { FaFilter, FaArrowCircleLeft } from "react-icons/fa";
import { NavLink, List, ListInlineItem, Button } from 'reactstrap';
import Slidebar from "./Slidebar"
function SubHeader(props) {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);  
    return (
        <>
            <div className='subheader'>
                <Slidebar openSidebar={props.openSidebar} title={!props.isFilter ? props.titleButton : "Filter"} content={!props.isFilter ? props.AddUserContent : props.SlideBarContent} handleClose={props.handleClose} handleSubmit={!props.isFilter ? props.handleSubmit : props.filterSubmit } style={{ width: !props.isFilter ? '35rem' : '22rem' }}/>
                <List>
                    <ListInlineItem>{props.SubHeaderTitle}</ListInlineItem>
                    {props.userStatus}
                </List>
                <div className='subheadericon'>
                    <List>
                        <ListInlineItem>
                            {props.showButton ? <Button className={`btn-adduser ${props.customClass}`} onClick={props.toggleModal}>{props.titleButton}</Button> : null }
                        </ListInlineItem>
                        {props.ShowFilterIcon ? 
                        <ListInlineItem>
                        <div className='filtericon'><FaFilter onClick={props.toggleFilter} /></div>
                    </ListInlineItem> : ""}
                    {/* {props.ShowBackButton ? 
                        <ListInlineItem>
                            <div className='btn-back'>
                                <NavLink onClick={goBack} style={{padding: '0', color: '$st-secondary-bg'}}>
                                    <FaArrowCircleLeft style={{fontSize: '18px'}}/> Go Back
                                </NavLink>
                            </div>
                    </ListInlineItem> : ""} */}
                    </List>
                </div>
            </div>
        </>
    )
}

export default SubHeader